<template>
  <div class="stamped-io">
    <div v-if="$isGlobalStore" class="stamped-header-title">
      {{ $t('stamped_title') }}
    </div>
    <client-only>
      <div v-if="canShowReviewWidget">
        <review-widget
          :id="product.id"
          :name="product.name"
          :type="productType"
          :url="productUrl"
          :image="productImg"
          :locale="$store.state.locale"
        />
      </div>
    </client-only>
  </div>
</template>

<script>
import ReviewWidget from '~/components/product/ReviewWidget.vue'
import stampediolable from '~/mixins/stampediolable'

export default {
  name: 'Stampedio',
  components: {
    ReviewWidget,
  },
  mixins: [stampediolable],
  props: {
    productType: {
      type: String,
      default: null,
    },
    product: {
      type: Object,
      required: true,
    },
    currentPrice: {
      type: Number,
      default: null,
    },
  },
  computed: {
    productUrl() {
      return `${
        this.$store.state?.siteStore?.urls?.production || this.storeUrl
      }/${this.product?.slug}/p`
    },
    productImg() {
      return this.product?.images?.[0]?.url
    },
    stampedProductImg() {
      const isLastImg = [
        'lancheira-mix-coracoes-flutuantes-all-black',
        'lancheira-mix-bem-floral',
      ].includes(this.product.sku)

      const image = isLastImg
        ? this.product?.images?.[this.product?.images?.length - 1]?.url
        : this.product?.images?.[0]?.url
      return image
    },
    canShowReviewWidget() {
      return !!(this.product?.id && this.productType)
    },
  },
  watch: {
    productType(newVal) {
      setTimeout(() => {
        const stampedWidget = document.querySelector('#stamped-main-widget')
        if (stampedWidget) stampedWidget.innerHTML = ''
        this.dettachRichSnippetListener()
        this.attachRichSnippetListener()
        this.initStamped()
      }, 500)
    },
  },
  created() {
    if (process.client) {
      this.setCredentials()
      this.attachRichSnippetListener()
      this.loadStampedScript().then(this.initStamped)
    }
  },
  beforeDestroy() {
    this.dettachRichSnippetListener()
  },
  methods: {
    /* istanbul ignore next */
    richSnippet() {
      const { name } = this.product
      const priceCurrency = this.$store.state.currency

      const reviewCount = window
        .jQueryStamped('meta[itemprop="reviewCount"]')
        .attr('content')
      const ratingValue = window
        .jQueryStamped('meta[itemprop="ratingValue"]')
        .attr('content')

      const richSnippet = {
        '@context': 'http://schema.org',
        '@type': 'Product',
        name,
        image: this.stampedProductImg,
        brand: {
          '@type': 'Brand',
          name: 'Gocase',
        },
      }

      if (this.currentPrice) {
        richSnippet.offers = {
          '@type': 'Offer',
          price: this.currentPrice,
          priceCurrency,
          itemCondition: 'new',
        }
      }

      if (parseInt(ratingValue) > 0) {
        richSnippet.aggregateRating = {
          '@type': 'AggregateRating',
          ratingValue,
          reviewCount,
        }
      }

      const script = document.createElement('script')
      script.type = 'application/ld+json'
      script.innerHTML = JSON.stringify(richSnippet)
      document.getElementsByTagName('head')[0].appendChild(script)

      this.forceBadgeseLoad()
    },
    // Bugfix: force load badges on client-side
    forceBadgeseLoad() {
      if (!this.isBadgesLoaded) window.StampedFn.loadBadges()
    },
    setBadgeLoaded() {
      this.isBadgesLoaded = true
    },
    attachRichSnippetListener() {
      document.addEventListener('stamped:reviews:loaded', this.richSnippet)
      document.addEventListener('stamped:badges:loaded', this.setBadgeLoaded)
    },
    dettachRichSnippetListener() {
      document.removeEventListener('stamped:reviews:loaded', this.richSnippet)
      document.removeEventListener('stamped:badges:loaded', this.setBadgeLoaded)
    },
  },
}
</script>
